// import React, { useState } from "react";
// import {
//   Drawer,
//   Typography,
//   Button,
//   IconButton,
//   Chip,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Box,
//   Paper,
//   Stack,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import SendIcon from "@mui/icons-material/Send";
// import { AiOutlineIdcard } from "react-icons/ai";
// import { SlGraduation } from "react-icons/sl";
// import { MdWorkOutline } from "react-icons/md";
// import { RiHome4Line } from "react-icons/ri";
// import { IoDocumentTextOutline } from "react-icons/io5";
// import { useSelector } from "react-redux";
// // import RequestedDocumentList from "./SideFeedComponents/RequestedDocumentList";

// const DOCUMENT_CATEGORIES = [
//   {
//     category: "Identity & Personal",
//     icon: <AiOutlineIdcard style={{ fontSize: 20 }} />,
//     documents: [
//       "Aadhaar Card",
//       "PAN Card",
//       "Passport",
//       "Voter ID",
//       "Driving License",
//     ],
//   },
//   {
//     category: "Education",
//     icon: <SlGraduation style={{ fontSize: 20 }} />,
//     documents: [
//       "10th Marksheet",
//       "12th Marksheet",
//       "Graduation Degree",
//       "Post Graduation Degree",
//       "Diploma Certificate",
//       "Other Certifications",
//     ],
//   },
//   {
//     category: "Employment",
//     icon: <MdWorkOutline style={{ fontSize: 20 }} />,
//     documents: [
//       "Previous Offer Letter",
//       "Last 3 Months Salary Slips",
//       "Experience Letter",
//       "Relieving Letter",
//       "Bank Statement (3 months)",
//       "Form 16",
//     ],
//   },
//   {
//     category: "Address Proof",
//     icon: <RiHome4Line style={{ fontSize: 20 }} />,
//     documents: [
//       "Electricity Bill",
//       "Rent Agreement",
//       "Bank Passbook",
//       "Gas Bill",
//     ],
//   },
//   {
//     category: "Others",
//     icon: <IoDocumentTextOutline style={{ fontSize: 20 }} />,
//     documents: [
//       "Photograph (Passport Size)",
//       "Medical Certificate",
//       "Police Verification Certificate",
//       "Reference Letter",
//     ],
//   },
// ];

// const DocumentRequestSlider = ({ open, onClose, onSubmit, applicant }) => {
//   console.log("applicant", applicant)
//   const [selectedDocs, setSelectedDocs] = useState([]);
//   const [submitted, setSubmitted] = useState(false);
//   const [requestedDocs, setRequestedDocs] = useState([]);
//   const [expandedCategories, setExpandedCategories] = useState({
//     "Identity & Personal": true,
//     "Education": false,
//     "Employment": false,
//     "Address Proof": false,
//     "Others": false,
//   });
//  const requestedDocumentsData = useSelector((state) => state.jobs?.documentsData)
//  const requestedDocuments = requestedDocumentsData?.uploaded_docs
//  console.log("requestedDocumentsNNNN", requestedDocuments)

//   const toggleDocument = (doc) => {
//     setSelectedDocs((prev) =>
//       prev.includes(doc) ? prev.filter((d) => d !== doc) : [...prev, doc]
//     );
//   };

//   const selectAllInCategory = (categoryDocs) => {
//     const allSelected = categoryDocs.every(doc => selectedDocs.includes(doc));

//     if (allSelected) {
//       setSelectedDocs((prev) => prev.filter((doc) => !categoryDocs.includes(doc)));
//     } else {
//       const newDocs = categoryDocs.filter((doc) => !selectedDocs.includes(doc));
//       setSelectedDocs((prev) => [...prev, ...newDocs]);
//     }
//   };

//   const handleAccordionChange = (category) => (event, isExpanded) => {
//     setExpandedCategories((prev) => ({
//       ...prev,
//       [category]: isExpanded,
//     }));
//   };

//   const handleSubmit = () => {
//     if (selectedDocs.length === 0) return;
//     setRequestedDocs(selectedDocs);
//     setSubmitted(true);
//     if (onSubmit) onSubmit(selectedDocs);
//   };

//   const handleClose = () => {
//     setSelectedDocs([]);
//     setSubmitted(false);
//     setRequestedDocs([]);
//     onClose();
//   };

//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={handleClose}
//       sx={{ "& .MuiDrawer-paper": { width: 420, padding: 0 } }}
//     >
//      {/* <RequestedDocumentList applicant={applicant} /> */}



//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           height: "100%",
//           bgcolor: "white",
//           overflow: "hidden",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             padding: "20px 24px",
//             borderBottom: "1px solid #f0f2f5",
//             flexShrink: 0,
//           }}
//         >
//           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//             <Box>
//               <Typography
//                 variant="h6"
//                 sx={{ color: "black", fontWeight: 700, fontSize: "1.1rem" }}
//               >
//                 Request Documents
//               </Typography>
//               <Typography
//                 variant="body2"
//                 sx={{ color: "rgba(14, 13, 13, 0.92)", marginTop: 2 }}
//               >
//                 {applicant?.name || "Candidate"} •{" "}
//                 {selectedDocs.length} selected
//               </Typography>
//             </Box>
//             <IconButton onClick={handleClose} sx={{ color: "#6b7280" }}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </Box>

//         {/* Submitted State */}
//         {submitted ? (
//           <Box sx={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
//             {/* Success Banner */}
//             <Box
//               sx={{
//                 background: "#f0fdf4",
//                 borderBottom: "1px solid #bbf7d0",
//                 padding: "16px 24px",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 10,
//                 flexShrink: 0,
//               }}
//             >
//               <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 20 }} />
//               <Typography
//                 variant="body2"
//                 sx={{ color: "#15803d", fontWeight: 600 }}
//               >
//                 Document request sent successfully!
//               </Typography>
//             </Box>

//             {/* Requested Docs List */}
//             <Box
//               sx={{
//                 flex: 1,
//                 overflowY: "auto",
//                 padding: "20px 24px",
//               }}
//             >
//               <Typography
//                 variant="subtitle2"
//                 sx={{
//                   color: "#374151",
//                   fontWeight: 700,
//                   marginBottom: 12,
//                   fontSize: "0.85rem",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.05em",
//                 }}
//               >
//                 Requested Documents ({requestedDocs.length})
//               </Typography>

//               <Box sx={{ display: "flex", flexDirection: "column", gap: 8 }}>
//                 {requestedDocs.map((doc, i) => (
//                   <Box
//                     key={i}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 10,
//                       padding: "10px 14px",
//                       background: "#f8faff",
//                       borderRadius: 10,
//                       border: "1px solid #dbeafe",
//                     }}
//                   >
//                     <DescriptionOutlinedIcon
//                       sx={{ color: "#0044C6", fontSize: 18 }}
//                     />
//                     <Typography
//                       variant="body2"
//                       sx={{ color: "#1e3a8a", fontWeight: 500 }}
//                     >
//                       {doc}
//                     </Typography>
//                     <CheckCircleIcon
//                       sx={{
//                         color: "#16a34a",
//                         fontSize: 16,
//                         marginLeft: "auto",
//                       }}
//                     />
//                   </Box>
//                 ))}
//               </Box>
//             </Box>

//             <Box
//               sx={{
//                 padding: "16px 24px",
//                 borderTop: "1px solid #f3f4f6",
//                 flexShrink: 0,
//               }}
//             >
//               <Button
//                 onClick={handleClose}
//                 variant="contained"
//                 fullWidth
//                 sx={{
//                   background: "#0044C6",
//                   borderRadius: 10,
//                   textTransform: "none",
//                   fontWeight: 600,
//                   padding: "10px 0",
//                 }}
//               >
//                 Done
//               </Button>
//             </Box>
//           </Box>
//         ) : (
//           /* Selection State */
//           <Box sx={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
//             {/* Info bar */}
//             <Box
//               sx={{
//                 padding: "12px 24px",
//                 background: "#f8faff",
//                 borderBottom: "1px solid #e0e7ff",
//                 flexShrink: 0,
//               }}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{ color: "#4b5563", fontSize: "0.82rem" }}
//               >
//                 Select the documents you'd like to request from the candidate.
//                 They'll be notified to upload them.
//               </Typography>
//             </Box>

//             {/* Document Categories with Accordion */}
//             <Box
//               sx={{
//                 flex: 1,
//                 overflowY: "auto",
//                 padding: "8px 0",
//               }}
//             >
//               {DOCUMENT_CATEGORIES.map((cat, idx) => {
//                 const categoryDocs = cat.documents;
//                 const allSelectedInCategory = categoryDocs.length > 0 && 
//                   categoryDocs.every(doc => selectedDocs.includes(doc));
//                 const selectedCountInCategory = categoryDocs.filter(doc => selectedDocs.includes(doc)).length;

//                 return (
//                   <Accordion
//                     key={cat.category}
//                     expanded={expandedCategories[cat.category]}
//                     onChange={handleAccordionChange(cat.category)}
//                     sx={{
//                       boxShadow: "none",
//                       "&:before": {
//                         display: "none",
//                       },
//                       borderBottom: idx !== DOCUMENT_CATEGORIES.length - 1 ? "1px solid #f0f2f5" : "none",
//                     }}
//                   >
//                     <AccordionSummary
//                       expandIcon={<ExpandMoreIcon sx={{ color: "#64748b" }} />}
//                       sx={{
//                         padding: "0 20px",
//                         minHeight: 56,
//                         "& .MuiAccordionSummary-content": {
//                           margin: "12px 0",
//                         },
//                         "&:hover": {
//                           bgcolor: "#fafafa",
//                         },
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "space-between",
//                           width: "100%",
//                           marginRight: 12,
//                         }}
//                       >
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 10 }}>
//                           <Box sx={{ fontSize: 20, color: "#0044C6" }}>{cat.icon}</Box>
//                           <Typography
//                             variant="subtitle1"
//                             sx={{
//                               color: "#1e293b",
//                               fontWeight: 600,
//                               fontSize: "0.9rem",
//                             }}
//                           >
//                             {cat.category}
//                           </Typography>
//                           {selectedCountInCategory > 0 && (
//                             <Chip
//                               label={`${selectedCountInCategory}/${categoryDocs.length} selected`}
//                               size="small"
//                               sx={{
//                                 height: 20,
//                                 fontSize: "0.7rem",
//                                 bgcolor: "#dbeafe",
//                                 color: "#1e40af",
//                                 fontWeight: 600,
//                               }}
//                             />
//                           )}
//                         </Box>

//                         <Button
//                           size="small"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             selectAllInCategory(categoryDocs);
//                           }}
//                           sx={{
//                             textTransform: "none",
//                             fontSize: "0.7rem",
//                             fontWeight: 600,
//                             minWidth: "auto",
//                             color: allSelectedInCategory ? "#dc2626" : "#0044C6",
//                             "&:hover": {
//                               bgcolor: "transparent",
//                               color: allSelectedInCategory ? "#b91c1c" : "#0035a0",
//                             },
//                           }}
//                         >
//                           {allSelectedInCategory ? "Deselect All" : "Select All"}
//                         </Button>
//                       </Box>
//                     </AccordionSummary>

//                     <AccordionDetails sx={{ padding: "0 20px 16px 20px" }}>
//                       <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//                         {cat.documents.map((doc) => {
//                           const isSelected = selectedDocs.includes(doc);
//                           return (
//                             <Box
//                               key={doc}
//                               onClick={() => toggleDocument(doc)}
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                                 padding: "10px 14px",
//                                 borderRadius: 10,
//                                 border: isSelected
//                                   ? "1.5px solid #0044C6"
//                                   : "1.5px solid #e5e7eb",
//                                 background: isSelected ? "#f0f5ff" : "#fafafa",
//                                 cursor: "pointer",
//                                 transition: "all 0.15s ease",
//                               }}
//                             >
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: 10,
//                                 }}
//                               >
//                                 <DescriptionOutlinedIcon
//                                   sx={{
//                                     color: isSelected ? "#0044C6" : "#9ca3af",
//                                     fontSize: 18,
//                                   }}
//                                 />
//                                 <Typography
//                                   variant="body2"
//                                   sx={{
//                                     color: isSelected ? "#0044C6" : "#374151",
//                                     fontWeight: isSelected ? 600 : 400,
//                                     fontSize: "0.875rem",
//                                   }}
//                                 >
//                                   {doc}
//                                 </Typography>
//                               </Box>

//                               {isSelected ? (
//                                 <CheckCircleIcon
//                                   sx={{ color: "#0044C6", fontSize: 20 }}
//                                 />
//                               ) : (
//                                 <RadioButtonUncheckedIcon
//                                   sx={{ color: "#d1d5db", fontSize: 20 }}
//                                 />
//                               )}
//                             </Box>
//                           );
//                         })}
//                       </Box>
//                     </AccordionDetails>
//                   </Accordion>
//                 );
//               })}
//             </Box>

//             {/* Selected chips preview + submit */}
//             <Box
//               sx={{
//                 padding: "10px 24px",
//                 borderTop: "1px solid #f3f4f6",
//                 background: "white",
//                 flexShrink: 0,
//               }}
//             >
//               {selectedDocs?.length > 0 && (
//                 <Box sx={{ marginBottom: 6 }}>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: "#6b7280",
//                       fontWeight: 600,
//                       display: "block",
//                       marginBottom: 6,
//                     }}
//                   >
//                     Selected ({selectedDocs?.length}):
//                   </Typography>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexWrap: "wrap",
//                       gap: 2,
//                       maxHeight: 80,
//                       overflowY: "auto",
//                     }}
//                   >
//                     {selectedDocs?.map((doc) => (
//                       <Chip
//                         key={doc}
//                         label={doc}
//                         size="small"
//                         onDelete={() => toggleDocument(doc)}
//                         sx={{
//                           background: "#dbeafe",
//                           color: "#1e40af",
//                           fontSize: "0.72rem",
//                           height: 24,
//                           fontWeight: 600,
//                         }}
//                       />
//                     ))}
//                   </Box>
//                 </Box>
//               )}

//               <Box sx={{ display: "flex", gap: 10 }}>
//                 <Button
//                   onClick={handleClose}
//                   variant="outlined"
//                   fullWidth
//                   sx={{
//                     borderColor: "#d1d5db",
//                     color: "#6b7280",
//                     borderRadius: 10,
//                     textTransform: "none",
//                     fontWeight: 600,
//                     padding: "10px 0",
//                   }}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   onClick={handleSubmit}
//                   variant="contained"
//                   fullWidth
//                   disabled={selectedDocs.length === 0}
//                   endIcon={<SendIcon sx={{ fontSize: 16 }} />}
//                   sx={{
//                     background: selectedDocs.length === 0 ? "#e5e7eb" : "#0044C6",
//                     color: selectedDocs.length === 0 ? "#9ca3af" : "white",
//                     borderRadius: 10,
//                     textTransform: "none",
//                     fontWeight: 600,
//                     padding: "10px 0",
//                     boxShadow: "none",
//                   }}
//                 >
//                   Send Request
//                 </Button>
//               </Box>
//             </Box>
//           </Box>
//         )}
//       </Box>
//     </Drawer>
//   );
// };

// export default DocumentRequestSlider;





import React, { useState } from "react";
import {
  Drawer,
  Typography,
  Button,
  IconButton,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SendIcon from "@mui/icons-material/Send";
import { AiOutlineIdcard } from "react-icons/ai";
import { SlGraduation } from "react-icons/sl";
import { MdWorkOutline } from "react-icons/md";
import { RiHome4Line } from "react-icons/ri";
import { IoDocumentTextOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import RequestedDocumentList from "./SideFeedComponents/RequestedDocumentList";

const DOCUMENT_CATEGORIES = [
  {
    category: "Identity & Personal",
    icon: <AiOutlineIdcard style={{ fontSize: 20 }} />,
    documents: [
      "Aadhar Card",
      "PAN Card",
      "Passport",
      "Voter ID",
      "Driving License",
    ],
  },
  {
    category: "Education",
    icon: <SlGraduation style={{ fontSize: 20 }} />,
    documents: [
      "10th Marksheet",
      "12th Marksheet",
      "Graduation Degree",
      "Post Graduation Degree",
      "Diploma Certificate",
      "Other Certifications",
    ],
  },
  {
    category: "Employment",
    icon: <MdWorkOutline style={{ fontSize: 20 }} />,
    documents: [
      "Previous Offer Letter",
      "Last 3 Months Salary Slips",
      "Experience Letter",
      "Relieving Letter",
      "Bank Statement (3 months)",
      "Form 16",
    ],
  },
  {
    category: "Address Proof",
    icon: <RiHome4Line style={{ fontSize: 20 }} />,
    documents: [
      "Electricity Bill",
      "Rent Agreement",
      "Bank Passbook",
      "Gas Bill",
    ],
  },
  {
    category: "Others",
    icon: <IoDocumentTextOutline style={{ fontSize: 20 }} />,
    documents: [
      "Photograph (Passport Size)",
      "Medical Certificate",
      "Police Verification Certificate",
      "Reference Letter",
    ],
  },
];

const DocumentRequestSlider = ({ open, onClose, onSubmit, applicant }) => {
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [mandatoryDocs, setMandatoryDocs] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [requestedDocs, setRequestedDocs] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({
    "Identity & Personal": true,
    "Education": false,
    "Employment": false,
    "Address Proof": false,
    "Others": false,
  });

  const requestedDocumentsData = useSelector((state) => state.jobs?.documentsData);
  const requestedDocuments = requestedDocumentsData?.uploaded_docs || [];

  const DocsStatus = requestedDocumentsData?.uploaded_docs_status
  // console.log("Blaaaaaaaaaa", DocsStatus == "APPROVED")
  // Create a map of uploaded documents for quick lookup
  const uploadedDocsMap = React.useMemo(() => {
    const map = new Map();
    requestedDocuments.forEach(doc => {
      if (doc.file_url) {
        map.set(doc.file_name, doc);
      }
    });
    return map;
  }, [requestedDocuments]);

  // Create a set of already requested documents
  const requestedDocsSet = React.useMemo(() => {
    return new Set(requestedDocuments.map(doc => doc.file_name));
  }, [requestedDocuments]);

  // Check if a document is already requested
  const isDocumentRequested = (docName) => {
    return requestedDocsSet.has(docName);
  };

  // Check if a document is already uploaded
  const isDocumentUploaded = (docName) => {
    return uploadedDocsMap.has(docName);
  };

  // Check if document is disabled (either requested or uploaded)
  const isDocumentDisabled = (docName) => {
    return isDocumentRequested(docName) || isDocumentUploaded(docName);
  };

  console.log("requestedDocsNNN", requestedDocs);
  console.log("requestedDocumentsNNNN", requestedDocuments);

  const toggleDocument = (doc) => {
    // Don't allow toggling if document is already requested or uploaded
    if (isDocumentDisabled(doc)) return;

    setSelectedDocs((prev) => {
      const isRemoving = prev.includes(doc);
      if (isRemoving) {
        // also clear its mandatory flag when deselected
        setMandatoryDocs((m) => m.filter((d) => d !== doc));
        return prev.filter((d) => d !== doc);
      }
      return [...prev, doc];
    });
  };

  const toggleMandatory = (doc, e) => {
    e.stopPropagation();
    // Don't allow toggling mandatory for disabled documents
    if (isDocumentDisabled(doc)) return;

    setMandatoryDocs((prev) =>
      prev.includes(doc) ? prev.filter((d) => d !== doc) : [...prev, doc]
    );
  };

  const selectAllInCategory = (categoryDocs) => {
    // Filter out disabled documents from category
    const availableDocs = categoryDocs.filter(doc => !isDocumentDisabled(doc));
    const allSelected = availableDocs.every(doc => selectedDocs.includes(doc));

    if (allSelected) {
      setSelectedDocs((prev) => prev.filter((doc) => !availableDocs.includes(doc)));
      setMandatoryDocs((prev) => prev.filter((doc) => !availableDocs.includes(doc)));
    } else {
      const newDocs = availableDocs.filter((doc) => !selectedDocs.includes(doc));
      setSelectedDocs((prev) => [...prev, ...newDocs]);
    }
  };

  const handleAccordionChange = (category) => (event, isExpanded) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: isExpanded,
    }));
  };

  const handleSubmit = () => {
    if (selectedDocs.length === 0) return;

    // Build payload with is_mandatory flag per document
    const docsPayload = selectedDocs.map((doc) => ({
      file_name: doc,
      is_mandatory: mandatoryDocs.includes(doc),
    }));

    setRequestedDocs((prev) => [...prev, ...docsPayload]);
    setSubmitted(true);
    if (onSubmit) onSubmit(docsPayload);
  };

  const handleClose = () => {
    setSelectedDocs([]);
    setMandatoryDocs([]);
    setSubmitted(false);
    // Don't clear requestedDocs on close, keep them for the session
    onClose();
  };

  // Reset submitted state when opening the drawer
  React.useEffect(() => {
    if (open) {
      setSubmitted(false);
      setSelectedDocs([]);
      setMandatoryDocs([]);
    }
  }, [open]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: 420,
          padding: 0,
          overflow: "hidden" // Keep this to prevent double scrollbars
        }
      }}
    >
      {/* Single scrollable container */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          bgcolor: "white",
          overflow: "auto", // Changed from "scroll" to "auto" for better UX
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#c1c1c1",
            borderRadius: "3px",
            "&:hover": {
              background: "#a8a8a8",
            },
          },
        }}
      >

        {DocsStatus == "APPROVED" ? "" : <Box
          sx={{
            padding: "20px 24px",
            borderBottom: "1px solid #f0f2f5",
            flexShrink: 0,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box>
              <Typography
                variant="h6"
                sx={{ color: "black", fontWeight: 700, fontSize: "1.1rem" }}
              >
                Request Documents
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "rgba(14, 13, 13, 0.92)", marginTop: 2 }}
              >
                {applicant?.name || "Candidate"} •{" "}
                {selectedDocs.length} selected
              </Typography>
            </Box>
            <IconButton onClick={handleClose} sx={{ color: "#6b7280" }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>}

        {/* Header */}
        <Box sx={{ flexShrink: 0 }}>
          <RequestedDocumentList applicant={applicant} />
        </Box>



        {/* Submitted State */}
        {submitted ? (
          <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
            {/* Success Banner */}
            <Box
              sx={{
                background: "#f0fdf4",
                borderBottom: "1px solid #bbf7d0",
                padding: "16px 24px",
                display: "flex",
                alignItems: "center",
                gap: 10,
                flexShrink: 0,
              }}
            >
              <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 20 }} />
              <Typography
                variant="body2"
                sx={{ color: "#15803d", fontWeight: 600 }}
              >
                Document request sent successfully!
              </Typography>
            </Box>

            {/* Requested Docs List */}
            <Box
              sx={{
                flex: 1,
                padding: "20px 24px",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#374151",
                  fontWeight: 700,
                  marginBottom: 2,
                  fontSize: "0.85rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                }}
              >
                Requested Documents ({requestedDocs?.length})
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {requestedDocs?.map((doc, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      padding: "10px 14px",
                      background: doc.is_mandatory ? "#fff7f7" : "#f8faff",
                      borderRadius: 10,
                      border: doc.is_mandatory
                        ? "1px solid #fecaca"
                        : "1px solid #dbeafe",
                    }}
                  >
                    <DescriptionOutlinedIcon
                      sx={{
                        color: doc.is_mandatory ? "#dc2626" : "#0044C6",
                        fontSize: 18,
                      }}
                    />

                    <Typography
                      variant="body2"
                      sx={{ color: "#1e3a8a", fontWeight: 500 }}
                    >
                      {doc.file_name}
                      {doc.is_mandatory && (
                        <span style={{ color: "#dc2626", fontWeight: 700, marginLeft: 2 }}>
                          *
                        </span>
                      )}
                    </Typography>
                    {doc.is_mandatory && (
                      <Chip
                        label="Mandatory"
                        size="small"
                        sx={{
                          height: 18,
                          fontSize: "0.62rem",
                          fontWeight: 700,
                          bgcolor: "#fee2e2",
                          color: "#b91c1c",
                          marginLeft: "auto",
                        }}
                      />
                    )}
                    <CheckCircleIcon
                      sx={{
                        color: "#16a34a",
                        fontSize: 16,
                        marginLeft: doc.is_mandatory ? 6 : "auto",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </Box>

            <Box
              sx={{
                padding: "16px 24px",
                borderTop: "1px solid #f3f4f6",
                flexShrink: 0,
              }}
            >
              <Button
                onClick={handleClose}
                variant="contained"
                fullWidth
                sx={{
                  background: "#0044C6",
                  borderRadius: 10,
                  textTransform: "none",
                  fontWeight: 600,
                  padding: "10px 0",
                  "&:hover": {
                    background: "#0035a0",
                  }
                }}
              >
                Done
              </Button>
            </Box>
          </Box>
        ) : (
          /* Selection State */
          <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
            {/* Info bar */}
            {DocsStatus == "APPROVED"? "" : <Box
              sx={{
                padding: "12px 24px",
                background: "#f8faff",
                borderBottom: "1px solid #e0e7ff",
                flexShrink: 0,
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#4b5563", fontSize: "0.82rem" }}
              >
                Select the documents you'd like to request from the candidate.
                Click "Mandatory" on a selected doc to require it.
              </Typography>
              {requestedDocuments.length > 0 && (
                <Typography
                  variant="body2"
                  sx={{
                    color: "#f59e0b",
                    fontSize: "0.82rem",
                    marginTop: 1,
                    fontWeight: 600
                  }}
                >
                  ⚡ {requestedDocuments.length} document(s) already requested
                </Typography>
              )}
              {uploadedDocsMap.size > 0 && (
                <Typography
                  variant="body2"
                  sx={{
                    color: "#16a34a",
                    fontSize: "0.82rem",
                    marginTop: 1,
                    fontWeight: 600
                  }}
                >
                  ✅ {uploadedDocsMap.size} document(s) already uploaded by candidate
                </Typography>
              )}
            </Box>}

            {/* Document Categories with Accordion - Removed overflow wrapper */}
            {DocsStatus == "APPROVED"? "" : <Box
              sx={{
                padding: "8px 0",
              }}
            >
              {DOCUMENT_CATEGORIES.map((cat, idx) => {
                const categoryDocs = cat.documents;
                // Filter out disabled documents for selection count
                const availableDocs = categoryDocs.filter(doc => !isDocumentDisabled(doc));
                const allSelectedInCategory = availableDocs.length > 0 &&
                  availableDocs.every(doc => selectedDocs.includes(doc));
                const selectedCountInCategory = availableDocs.filter(doc => selectedDocs.includes(doc)).length;
                const disabledCountInCategory = categoryDocs.filter(doc => isDocumentDisabled(doc)).length;

                return (
                  <Accordion
                    key={cat.category}
                    expanded={expandedCategories[cat.category]}
                    onChange={handleAccordionChange(cat.category)}
                    sx={{
                      boxShadow: "none",
                      "&:before": {
                        display: "none",
                      },
                      borderBottom: idx !== DOCUMENT_CATEGORIES.length - 1 ? "1px solid #f0f2f5" : "none",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#64748b" }} />}
                      sx={{
                        padding: "0 20px",
                        minHeight: 56,
                        "& .MuiAccordionSummary-content": {
                          margin: "12px 0",
                        },
                        "&:hover": {
                          bgcolor: "#fafafa",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          marginRight: 12,
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <Box sx={{ fontSize: 20, color: "#0044C6" }}>{cat.icon}</Box>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              color: "#1e293b",
                              fontWeight: 600,
                              fontSize: "0.9rem",
                            }}
                          >
                            {cat.category}
                          </Typography>
                          {selectedCountInCategory > 0 && (
                            <Chip
                              label={`${selectedCountInCategory}/${availableDocs.length} selected`}
                              size="small"
                              sx={{
                                height: 20,
                                fontSize: "0.7rem",
                                bgcolor: "#dbeafe",
                                color: "#1e40af",
                                fontWeight: 600,
                              }}
                            />
                          )}
                          {disabledCountInCategory > 0 && (
                            <Chip
                              label={`${disabledCountInCategory} disabled`}
                              size="small"
                              sx={{
                                height: 20,
                                fontSize: "0.7rem",
                                bgcolor: "#fef3c7",
                                color: "#d97706",
                                fontWeight: 600,
                              }}
                            />
                          )}
                        </Box>

                        {availableDocs.length > 0 && (
                          <Button
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              selectAllInCategory(categoryDocs);
                            }}
                            sx={{
                              textTransform: "none",
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              minWidth: "auto",
                              color: allSelectedInCategory ? "#dc2626" : "#0044C6",
                              "&:hover": {
                                bgcolor: "transparent",
                                color: allSelectedInCategory ? "#b91c1c" : "#0035a0",
                              },
                            }}
                          >
                            {allSelectedInCategory ? "Deselect All" : "Select All"}
                          </Button>
                        )}
                      </Box>
                    </AccordionSummary>

                    <AccordionDetails sx={{ padding: "0 20px 16px 20px" }}>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {cat.documents.map((doc) => {
                          const isSelected = selectedDocs.includes(doc);
                          const isMandatory = mandatoryDocs.includes(doc);
                          const isRequested = isDocumentRequested(doc);
                          const isUploaded = isDocumentUploaded(doc);
                          const isDisabled = isRequested || isUploaded;

                          // Determine status text
                          let statusText = "";
                          let statusColor = "";
                          if (isUploaded) {
                            statusText = "(Uploaded)";
                            statusColor = "#16a34a";
                          } else if (isRequested) {
                            statusText = "(Requested)";
                            statusColor = "#d97706";
                          }

                          return (
                            <Box
                              key={doc}
                              onClick={() => {
                                // Don't allow selection if already disabled
                                if (!isDisabled) {
                                  toggleDocument(doc);
                                }
                              }}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "10px 14px",
                                borderRadius: 10,
                                border: isDisabled
                                  ? isUploaded
                                    ? "1.5px solid #86efac"
                                    : "1.5px solid #fcd34d"
                                  : isSelected
                                    ? isMandatory
                                      ? "1.5px solid #dc2626"
                                      : "1.5px solid #0044C6"
                                    : "1.5px solid #e5e7eb",
                                background: isDisabled
                                  ? isUploaded
                                    ? "#f0fdf4"
                                    : "#fffbeb"
                                  : isSelected
                                    ? isMandatory
                                      ? "#fff5f5"
                                      : "#f0f5ff"
                                    : "#fafafa",
                                cursor: isDisabled ? "default" : "pointer",
                                transition: "all 0.15s ease",
                                opacity: isDisabled ? 0.85 : 1,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 10,
                                  minWidth: 0,
                                }}
                              >
                                <DescriptionOutlinedIcon
                                  sx={{
                                    color: isDisabled
                                      ? isUploaded
                                        ? "#16a34a"
                                        : "#d97706"
                                      : isSelected
                                        ? isMandatory
                                          ? "#dc2626"
                                          : "#0044C6"
                                        : "#9ca3af",
                                    fontSize: 18,
                                    flexShrink: 0,
                                  }}
                                />
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: isDisabled
                                      ? isUploaded
                                        ? "#16a34a"
                                        : "#d97706"
                                      : isSelected
                                        ? isMandatory
                                          ? "#dc2626"
                                          : "#0044C6"
                                        : "#374151",
                                    fontWeight: isDisabled ? 600 : (isSelected ? 600 : 400),
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  {doc}
                                  {isMandatory && !isDisabled && (
                                    <span style={{ color: "#dc2626", fontWeight: 700, marginLeft: 2 }}>
                                      *
                                    </span>
                                  )}
                                  {statusText && (
                                    <span style={{
                                      color: statusColor,
                                      fontWeight: 600,
                                      marginLeft: 6,
                                      fontSize: "0.7rem"
                                    }}>
                                      {statusText}
                                    </span>
                                  )}
                                </Typography>
                              </Box>

                              <Box sx={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                                {isSelected && !isDisabled && (
                                  <Chip
                                    label="Mandatory"
                                    size="small"
                                    onClick={(e) => toggleMandatory(doc, e)}
                                    sx={{
                                      height: 22,
                                      fontSize: "0.62rem",
                                      fontWeight: 700,
                                      cursor: "pointer",
                                      bgcolor: isMandatory ? "#fee2e2" : "transparent",
                                      color: isMandatory ? "#b91c1c" : "#9ca3af",
                                      border: isMandatory
                                        ? "1px solid #fecaca"
                                        : "1px solid #d1d5db",
                                      "&:hover": {
                                        bgcolor: isMandatory ? "#fecaca" : "#f3f4f6",
                                      },
                                    }}
                                  />
                                )}
                                {isDisabled ? (
                                  isUploaded ? (
                                    <CheckCircleIcon
                                      sx={{
                                        color: "#16a34a",
                                        fontSize: 20,
                                      }}
                                    />
                                  ) : (
                                    <CheckCircleIcon
                                      sx={{
                                        color: "#d97706",
                                        fontSize: 20,
                                      }}
                                    />
                                  )
                                ) : isSelected ? (
                                  <CheckCircleIcon
                                    sx={{
                                      color: isMandatory ? "#dc2626" : "#0044C6",
                                      fontSize: 20,
                                    }}
                                  />
                                ) : (
                                  <RadioButtonUncheckedIcon
                                    sx={{ color: "#d1d5db", fontSize: 20 }}
                                  />
                                )}
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Box>}

            {/* Selected chips preview + submit */}
            {DocsStatus == "APPROVED"? "" : <Box
              sx={{
                padding: "10px 24px",
                borderTop: "1px solid #f3f4f6",
                background: "white",
                flexShrink: 0,
              }}
            >
              {/* Show disabled documents (requested + uploaded) */}
              {requestedDocs.length > 0 && (
                <Box sx={{ marginBottom: 6 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#d97706",
                      fontWeight: 600,
                      display: "block",
                      marginBottom: 6,
                    }}
                  >
                    ⚡ Already Requested ({requestedDocs.length}):
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                      maxHeight: 80,
                      overflowY: "auto",
                    }}
                  >
                    {requestedDocs.map((doc) => (
                      <Chip
                        key={doc.file_name}
                        label={doc.file_name}
                        size="small"
                        sx={{
                          background: "#fef3c7",
                          color: "#d97706",
                          fontSize: "0.72rem",
                          height: 24,
                          fontWeight: 600,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {uploadedDocsMap.size > 0 && (
                <Box sx={{ marginBottom: 6 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#16a34a",
                      fontWeight: 600,
                      display: "block",
                      marginBottom: 6,
                    }}
                  >
                    ✅ Already Uploaded ({uploadedDocsMap.size}):
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                      maxHeight: 80,
                      overflowY: "auto",
                    }}
                  >
                    {Array.from(uploadedDocsMap.keys()).map((doc) => (
                      <Chip
                        key={doc}
                        label={doc}
                        size="small"
                        sx={{
                          background: "#dcfce7",
                          color: "#16a34a",
                          fontSize: "0.72rem",
                          height: 24,
                          fontWeight: 600,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}

              {selectedDocs?.length > 0 && (
                <Box sx={{ marginBottom: 6 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#6b7280",
                      fontWeight: 600,
                      display: "block",
                      marginBottom: 6,
                    }}
                  >
                    Selected ({selectedDocs?.length}):
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                      maxHeight: 80,
                      overflowY: "auto",
                    }}
                  >
                    {selectedDocs?.map((doc) => {
                      const isMandatory = mandatoryDocs.includes(doc);
                      return (
                        <Chip
                          key={doc}
                          label={isMandatory ? `${doc} *` : doc}
                          size="small"
                          onDelete={() => toggleDocument(doc)}
                          sx={{
                            background: isMandatory ? "#fee2e2" : "#dbeafe",
                            color: isMandatory ? "#b91c1c" : "#1e40af",
                            fontSize: "0.72rem",
                            height: 24,
                            fontWeight: 600,
                          }}
                        />
                      );
                    })}
                  </Box>
                </Box>
              )}

              <Box sx={{ display: "flex", gap: 10 }}>
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  fullWidth
                  sx={{
                    borderColor: "#d1d5db",
                    color: "#6b7280",
                    borderRadius: 10,
                    textTransform: "none",
                    fontWeight: 600,
                    padding: "10px 0",
                    "&:hover": {
                      borderColor: "#9ca3af",
                      color: "#4b5563",
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  fullWidth
                  disabled={selectedDocs.length === 0}
                  endIcon={<SendIcon sx={{ fontSize: 16 }} />}
                  sx={{
                    background: selectedDocs.length === 0 ? "#e5e7eb" : "#0044C6",
                    color: selectedDocs.length === 0 ? "#9ca3af" : "white",
                    borderRadius: 10,
                    textTransform: "none",
                    fontWeight: 600,
                    padding: "10px 0",
                    boxShadow: "none",
                    "&:hover": {
                      background: selectedDocs.length === 0 ? "#e5e7eb" : "#0035a0",
                      boxShadow: "none",
                    },
                    "&:disabled": {
                      background: "#e5e7eb",
                      color: "#9ca3af",
                    }
                  }}
                >
                  Send Request
                </Button>
              </Box>
            </Box>}
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default DocumentRequestSlider;